import { get } from "./authenticatedrequestUtil";

export const getGeneralLedger = get<{ GeneralLedger: Record<string, any> }>(
  ({ companyId, month, year }) => {
    let url = `/${companyId}/transactions/general-ledger`;
    const params = new URLSearchParams();
    
    if (month !== undefined) params.append('month', month.toString());
    if (year !== undefined) params.append('year', year.toString());
    
    const queryString = params.toString();
    return queryString ? `${url}?${queryString}` : url;
  }
);
